import { DestroyRef, inject, Service } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationStart, Router } from '@angular/router';

import { afterFrame } from '@elastic/apm-rum-core';

import { _BaasApm } from '@lvflanders/bar';

/** Angular APM service. */
@Service({ autoProvided: false })
export class _BaasApmService {
    readonly #apm = inject(_BaasApm);
    readonly #router = inject(Router);
    readonly #destroyRef = inject(DestroyRef);

    /** Initializes APM for Angular. */
    observe() {
        // init only observes, APM is normally setup in @lvflanders/bar
        if (!this.#apm.active) return;

        // NOTE based on https://github.com/elastic/apm-agent-rum-js/blob/main/packages/rum-angular/src/apm.service.ts
        // we didn't use this class because it was not Ivy compliant
        let transaction;
        this.#router.events.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe((event) => {
            const eventName = event.toString();
            if (eventName.indexOf('NavigationStart') >= 0) {
                const name = (event as NavigationStart).url;
                transaction = this.#apm.apm.startTransaction(name, 'route-change', {
                    managed: true,
                    canReuse: true
                });
            } else if (eventName.indexOf('NavigationError') >= 0) {
                if (transaction) transaction.detectFinish();
            } else if (eventName.indexOf('NavigationEnd') >= 0) {
                if (!transaction) {
                    return;
                }
                /**
                 * The below logic must be placed in NavigationEnd since
                 * the we depend on the current route state to get the path
                 *
                 * Even If there are any redirects, the router state path
                 * will be matched with the correct url on navigation end
                 *
                 * Traverse the activated route tree to figure out the nested
                 * route path
                 */
                const route = this.#router.routerState.root.firstChild;

                if (route) {
                    let child = route;
                    let path = '/' + child.routeConfig.path;
                    while (child) {
                        child = child.firstChild;
                        if (child && child.routeConfig) {
                            const currentPath = child.routeConfig.path;
                            /**
                             * Ignore empty path's in the route config
                             */
                            if (currentPath) {
                                path += '/' + currentPath;
                            }
                        }
                    }
                    transaction.name = path;
                }

                afterFrame(() => transaction.detectFinish());
            }
        });
    }
}
